import { contrastRatio } from '@yola/yola-palette-generator';
import priceLabelAccent from './price-label-accent';
import isDark from '../verifiers/is-dark';

const primaryButtonAccentDefault = ({
  targetColor,
  backgroundColor,
  targetColorPalette,
  whiteColor,
}) => {
  const buttonColor = priceLabelAccent({
    targetColor,
    backgroundColor,
    targetColorPalette,
    whiteColor,
    reduceCondition: (ratio) => ratio >= 1.5,
    increaseCondition: (ratio) => ratio >= 1.5,
  });
  if (isDark(backgroundColor)) {
    return contrastRatio(buttonColor, whiteColor) >= 3 ? buttonColor : whiteColor;
  }
  return buttonColor;
};

export default primaryButtonAccentDefault;
